import {
  GET_BRANDS_PENDING,
  GET_BRANDS_FULFILLED,
  GET_BRANDS_REJECTED,
  PATCH_BRANDS_ERROR,
} from '../actions/types';
import { dataBrand } from '../utils/dataSet';

const initialState = {
  data: dataBrand,
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_BRANDS_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_BRANDS_FULFILLED:
      return {
        ...state,
        data: { ...state.data, content: action.payload },
        loading: false,
        error: false,
      };
    case GET_BRANDS_REJECTED:
      return {
        ...state,
        data: dataBrand,
        loading: false,
        error: true,
      };
    case PATCH_BRANDS_ERROR:
      return {
        ...state,
        error: false,
      };
    default:
      return state;
  }
}
